import { render, staticRenderFns } from "./RegisterSuccess.vue?vue&type=template&id=4aee8b40&scoped=true&"
import script from "./RegisterSuccess.vue?vue&type=script&lang=ts&"
export * from "./RegisterSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterSuccess.vue?vue&type=style&index=0&id=4aee8b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aee8b40",
  null
  
)

export default component.exports